const Warnings = ({ listLength, number }) => {
  let modulo = listLength % parseInt(number);
  let messages = [];

  if (modulo > 0) {
    messages.push(`You'll have ${modulo} spare.`);
  }

  if (listLength < number) {
    messages.push("Too many teams.");
  }

  if (number !== "" && isNaN(parseInt(number))) {
    messages.push("Must be a number");
  }

  return (
    <div>
      {messages.map((item, index) => (
        <p key={index}>{item}</p>
      ))}
    </div>
  );
};

export default Warnings;
